import { CartItemSchema } from './CartItemSchema';
import { z } from 'zod';

export const CartItemGroupSchema = z.object({
  title: z.string(),
  description: z.string().nullable(),
  cart_items: z.array(CartItemSchema),
});
